import axios from "axios";
import Cookies from 'js-cookie';
import sha256 from 'js-sha256';
import React, { Fragment, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import backgroundImage from '../../assets/images/custom/haydarpaşa_liman.jpg';
import logo from '../../assets/images/custom/uklogo.jpg';
import edgemonLogo from '../../assets/images/custom/white.png';
import { goRiceUrl } from '../../constant/siteConstants';
import { login } from "../apiCall/LoginCall";

import devices from 'devextreme/core/devices';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'sweetalert2/src/sweetalert2.scss';
import { AuthService } from "../../auth";


export default function Login({ history }) {
    // const dispatch = useDispatch()

    let lang = localStorage.getItem("lang") !== "en" ? "tr" : "en"
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [type, setType] = useState("password")
    const [error, setError] = useState(false)
    const [modalAdd, setModalAdd] = useState(false)

    const userChange = (e) => {
        setUsername(e.target.value);
    }

    let user = localStorage.getItem("user");
    let token = Cookies.get("token");
    let fullName = localStorage.getItem("fullName");
    let roles = localStorage.getItem("roles");


    if (token && user && fullName && roles) {
        history.push("/index");

    }

    const passwordChange = (e) => {
        setPassword(sha256(e.target.value))
    }

    const loginWithAuth = async (e) => {

        e.preventDefault();
        localStorage.setItem("lang", lang)

        AuthService.clearCache();
        // localStorage.setItem("warehouse", "MjM=")
        // localStorage.setItem("roles", "eyJVc2VyUm9sZXMiOlsiZGVwb19yb2xlX2RlbGV0ZSIsImJvbGdlX3JvbGVfcmVhZCIsImJvbGdlX3JvbGVfd3JpdGUiLCJib2xnZV9yb2xlX2V4cG9ydCIsImJvbGdlX3JvbGVfZGVsZXRlIiwiYm9sZ2Vfcm9sZV91cGRhdGUiLCJkZXBvX3JvbGVfd3JpdGUiLCJkZXBvX3JvbGVfZXhwb3J0IiwiZGVwb19yb2xlX3VwZGF0ZSIsImRlcG9fcm9sZV9yZWFkIl0sIlNwZWNpYWxSb2xlcyI6W119")
        // localStorage.setItem("user", "bWVsaWtlQGRpYXRpY3MuY29t")
        // localStorage.setItem("fullName", "Melike Özlen")
        // localStorage.setItem("employee_id", "MzE4NTY3")
        // localStorage.setItem("expiratDate", "1735908192000")
        // localStorage.setItem("lang", lang)
        // Cookies.set('token', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlX21haWwiOiJtZWxpa2VAZGlhdGljcy5jb20iLCJlbXBsb3llZV9pZCI6MzE4NTY3LCJleHAiOjE3MzU5MDgxOTIsImZ1bGxfbmFtZSI6Ik1lbGlrZSDDlnpsZW4ifQ.96aS00C--r3eHwBx17Le65JL5eKms0pItf-x3zuoBiI")
        // setTimeout(() => {
        //     window.location.href = "/index"

        // }, 400);
        // return
        try {

            const response = await login(username, password)

            let token = response.data.token;
            let base64Url = token.split('.')[1]; // Token'in ikinci kısmı payload'dır
            let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));


            let full_name = JSON.parse(jsonPayload).full_name
            let email = JSON.parse(jsonPayload).e_mail
            let employee_id = JSON.parse(jsonPayload).employee_id

            localStorage.setItem("user", Buffer.from(email.toString()).toString('base64'))
            localStorage.setItem("fullName", full_name)
            localStorage.setItem("employee_id", Buffer.from(employee_id.toString()).toString('base64'))
            localStorage.setItem("expiratDate", JSON.parse(jsonPayload).exp * 1000)

            Cookies.set('token', token)
            getUserRoles(employee_id, token);


        } catch (error) {
            alert("Giriş yapılamadı lütfen tekrar deneyiniz")
            console.error(error)
            setError(true)
            Cookies.set('sessionKey', "")
        }
        /* eslint-enable */
    }

    async function getUserRoles(userId, token) {
        await axios.post(`${goRiceUrl}/api/employee/getRoles`, {
            employee_id: userId
        }, {
            headers: {
                "token": token
            }
        }).then(resp => {
            if (resp.status === 200) {
                const roleObject = {}
                const userRoles = []
                const specialRoles = []
                if (resp.data.UserRoles !== null) {
                    for (const role of resp.data.roles) {
                        userRoles.push(role.role_name)
                    }
                }

                if (resp.data.SpecialRole !== null) {
                    for (const role of resp.data.special_roles) {
                        specialRoles.push(role.role_name)
                    }
                }

                roleObject.UserRoles = userRoles
                roleObject.SpecialRoles = specialRoles

                getEmployeeByID(userId, token, btoa(JSON.stringify(roleObject)))

            } else {

                localStorage.setItem("roles", [])


            }
        })
    }


    const getAllWarehouses = async (token, path, roleObject, data) => {
        try {
            const response = await axios.post(`${goRiceUrl}/api/warehouse/getAll`, {}, {
                headers: { "token": token }
            });
            let all_data = response.data || [];
            let warehouses = all_data.filter(x =>
                x.id !== 18 && x.id !== 19 && x.id !== 34 && x.id !== 33 && x.id !== 28 && x.id !== 29
            );
            if (response.status === 200) {
                let depo = data.warehouse_id;
                Swal.fire({
                    title: '<div class="warehouse-title">📦 Depo Seçimi</div>',
                    html: `
                        <div class="warehouse-container">
                            <div class="warehouse-subtitle">Lütfen çalışmak istediğiniz depoyu seçiniz</div>
                            <select id="warehouseSelect" class="warehouse-select">
                                <option value="" disabled selected>Depo Seçiniz</option>
                                ${warehouses.map((warehouse, index) => `
                                    <option value="${warehouse.id}" ${depo === warehouse.id ? 'selected' : ''}>
                                        ${warehouse.warehouse_name} (${warehouse.warehouse_code})
                                    </option>
                                `).join('')}
                            </select>
                            <div class="warehouse-info">
                                <i class="fa fa-info-circle"></i> 
                                Seçiminizi yaptıktan sonra "Onayla" butonuna tıklayınız
                            </div>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonText: 'Onayla',
                    cancelButtonText: 'İptal',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    customClass: {
                        popup: 'warehouse-popup',
                        title: 'warehouse-modal-title',
                        content: 'warehouse-content',
                        confirmButton: 'warehouse-confirm-btn',
                        cancelButton: 'warehouse-cancel-btn'
                    },
                    preConfirm: () => {
                        const selectedValue = document.getElementById('warehouseSelect').value;
                        if (!selectedValue) {
                            Swal.showValidationMessage('Lütfen bir depo seçimi yapınız!');
                            return false;
                        }
                        return selectedValue;
                    }
                }).then((result) => {
                    if (result.isConfirmed && result.value) {
                        const selectedWarehouse = warehouses.find(w => w.id === parseInt(result.value));

                        if (selectedWarehouse) {
                            localStorage.setItem(
                                "warehouse",
                                btoa(JSON.stringify(selectedWarehouse.id))
                            );
                            localStorage.setItem("warehouseName", selectedWarehouse.warehouse_name);

                            Swal.fire({
                                icon: 'success',
                                title: 'Depo Seçildi',
                                text: 'Ana sayfaya yönlendiriliyorsunuz...',
                                timer: 1500,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'warehouse-success-popup'
                                }
                            }).then(() => {
                                localStorage.setItem("roles", roleObject);
                                setTimeout(() => {
                                    if (path && path !== "") {
                                        window.location.href = path;
                                    } else {
                                        // history.push("/index");
                                        window.location.href = "/index";
                                    }
                                }, 1000);
                            });
                        }
                    }
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Hata',
                    text: 'Depo listesi alınamadı!',
                    customClass: {
                        popup: 'warehouse-error-popup'
                    }
                });
            }
        } catch (error) {
            console.error('Depo listesi alınırken hata:', error);
            Swal.fire({
                icon: 'error',
                title: 'Hata',
                text: 'Depo listesi alınırken bir hata oluştu!',
                customClass: {
                    popup: 'warehouse-error-popup'
                }
            });
        }
    };


    async function getEmployeeByID(userId, token, roleObject) {
        var isMobile = devices.current().deviceType === 'phone';
        await axios.post(`${goRiceUrl}/api/employee/getByEmployeeID`, {
            employee_id: userId
        }, {
            headers: {
                "token": token
            }
        }).then(resp => {
            if (resp.status === 200) {
                // the user's own interface language, kept on the account (row 8)
                if (["tr", "en", "fr"].includes(resp.data.language)) localStorage.setItem("lang", resp.data.language)
                if (isMobile) {
                    setTimeout(() => {
                        getAllWarehouses(token, resp.data.redirect_path, roleObject, resp.data)
                    }, 500);
                }
                else {
                    if (resp.data.warehouse_id !== null || resp.data.warehouse_id !== undefined) {
                        localStorage.setItem(
                            "warehouse",
                            btoa(JSON.stringify(resp.data.warehouse_id))
                        );
                    }
                    localStorage.setItem("roles", roleObject)
                    setTimeout(() => {
                        if (localStorage.getItem("loginRedirectUrl") !== null) {
                            let uri = localStorage.getItem("loginRedirectUrl")
                            localStorage.removeItem("loginRedirectUrl")
                            window.location.href = uri;
                        }
                        else if (resp.data.redirect_path && resp.data.redirect_path !== "") {
                            window.location.href = resp.data.redirect_path;
                        }
                        else {
                            // history.push("/index");
                            window.location.href = "/index"
                        }
                    }, 400);

                }
            } else {
                localStorage.setItem("roles", [])
            }
        })
            .catch((err) => {
                console.error(err);
            })
    }

    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="auth-bg" style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: '100% 100%', backgroundAttachment: "cover"
                }} >
                    <div className="authentication-box">
                        <div className="card mt-4">
                            <div className="card-body">
                                <div className="text-center"><img width="200px" src={logo} alt="" /></div>
                                <div className="text-center mt-5">
                                    <h4>Giriş Yap</h4>
                                    <h6>Kullanıcı adı ve şifrenizi giriniz. </h6>
                                </div>
                                <form className="theme-form">
                                    <div className="form-group">
                                        <label className="col-form-label pt-0">Kullanıcı Adı</label>
                                        <Input onChange={userChange} className="form-control" type="text" required="" id="password-value" />
                                    </div>
                                    <div className="form-group">
                                        <label className="col-form-label">Parola</label>
                                        <InputGroup>
                                            <Input onChange={passwordChange} className="form-control" type={type} required="" />
                                            <InputGroupAddon addonType="append" style={{ position: "relative" }}>
                                                {type === "password" ?
                                                    <InputGroupText onClick={() => setType("text")}>
                                                        <i className="icofont icofont-eye-alt" />
                                                    </InputGroupText> :
                                                    <InputGroupText onClick={() => setType("password")}>
                                                        <i className="icofont icofont-eye-blocked" />
                                                    </InputGroupText>
                                                }
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </div>
                                    <div className="form-group form-row mt-3 mb-0">
                                        <button onClick={loginWithAuth} className="btn btn-primary btn-block" type="submit">Giriş</button>
                                    </div>
                                    <div className='d-flex justify-content-end mt-3' onClick={() => { setModalAdd(true) }}>
                                        {/*  <i
                                            style={{ cursor: "pointer" }}
                                            className="text-primary"
                                        > Şifremi Unuttum</i>
                                        <LoginForgetPassword isOpen={modalAdd} setToggle={setModalAdd} />
                                  */}  </div>

                                </form>
                                <Alert className="mt-1" variant="danger" show={error}>Giriş yapılamadı lütfen tekrar deneyiniz</Alert>

                            </div>
                        </div>
                    </div><div className="mt-5 d-flex justify-content-end" style={{ color: "white", position: "absolute", left: "30px", bottom: "30px" }}>
                        <h6>
                            <img src={edgemonLogo} style={{ width: "20%" }} alt="edgemonlogo" /> | Alpha v2.0.0
                        </h6>
                    </div>
                </div>
            </div>
        </Fragment>


    )
}